import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../../utils/features";

export const APP_DOWNLOAD_NUDGE_FEATURE = "back_in_stock_nudge_enabled";

export default function useAppDownloadNudgeEnabled(): boolean {
  const { areFeaturesReady } = useFeaturesReady() as {
    areFeaturesReady: boolean;
  };

  return areFeaturesReady && getFeature(APP_DOWNLOAD_NUDGE_FEATURE).isEnabled();
}
